// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import { evalRatingClass } from '../utils/enUtils.js'

export class ModuleItem extends Component {
    render() {
        let statusMarkUp = ""

        if ('status' in this.props) {
            statusMarkUp = (
                <Row>
                    <Col sm={12}>
                        <p>
                            <span><b>Status: </b></span><span className={evalRatingClass(this.props.status)}>{this.props.status}</span>
                        </p>
                    </Col>
                </Row>
            )
        }

        return (
            <Row>
                <Col lg={2} md={4} sm={6}>
                    <div className="module-image">
                        <img src={this.props.image} alt={this.props.name} />
                    </div>
                </Col>
                <Col lg={10} md={8} sm={6}>
                    <section className="module-info right-panel">
                        <Row>
                            <Col sm={12}>
                                <Row>
                                    <Col sm={12}>
                                        <h3>{this.props.name}</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <p>{this.props.summary}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <p><span><b>Categories: </b></span>{this.props.category}</p>
                                    </Col>
                                </Row>
                                {statusMarkUp}
                                {this.props.children}
                            </Col>
                        </Row>
                    </section>
                </Col>
            </Row>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/moduleItem.js